<template>
  <div id="DiamondData">
    <section class="diamond-header" v-if="loading == false">
      <div class="container-md">
        <div class="row">
          <!--div class="WishList" :class="diamondData.certificateNr == '' ? 'd-none' : 'col-12 col-md-4'">
						<span class="WishList-toggle-icon" :ref="'WishList-' + diamondData.pool_id" @click="toggleWishList(diamondData.pool_id)">
							<template v-if="isOnWishList[diamondData.pool_id]">&#9829;</template>
							<template v-else>&#9825;</template>
						</span>
					</div-->
          <div class="col-12 text-end set-pt set-height">
            <button
              class="btn btn-close"
              @click="router.go(-1)"
              v-if="showButton"
            ></button>
          </div>
        </div>
        <div class="row set-mt">
          <div class="col-12 col-sm-5 col-md-4 text-center">
            <video
              preload="none"
              width="200"
              height="200"
              loop
              muted
              playsinline
              autoplay
              controlsList="nodownload"
              class="diamond-clip"
            >
              <source
                :src="
                  appUrl +
                  '/img/assets/stones/forms/600/video/' +
                  (diamondData.picture == 'q' ? 'f' : diamondData.picture) +
                  '.mp4'
                "
                type="video/mp4"
              />
            </video>
            <div>
              {{ $t("Diamond.main.image.text") }}
            </div>
          </div>
          <div class="col-12 col-sm-7 col-md-7 offset-md-1">
            <div class="row">
              <div class="col text-center">
                <h1 class="mt-5">
                  {{ diamondData.stone_size }} {{ $t("Diamond.main.header") }}
                  <br />
                  {{ diamondData.stoneform }}
                </h1>
                <p>
                  {{ $t("Diamond.main.subHeader") }}
                  {{ diamondData.certificate }}
                  <template v-if="diamondData.stone_type === '5'">
                    -
                    <span class="set-color py-1 px-2"
                      >{{ $t("Diamond.details.header.labGrown") }}
                    </span></template
                  >
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col price">
                <span>{{ $t("Diamond.main.price") }}: </span>
                <span class="fw-bold">{{ $n(diamondPrice, "currency") }}</span>
              </div>
            </div>
            <div class="row appointmentOrOrder">
              <div
                :class="[
                  shopId > 10000 && articleNr !== ''
                    ? 'col text-center'
                    : 'd-none',
                ]"
              >
                <a
                  :href="configuratorUrl + articleNr + '/'"
                  class="btn btn-md set-font-size"
                  :class="[
                    diamondData.stone_type === '5'
                      ? 'btn-lab-grown'
                      : 'btn-real-diamond-stock',
                  ]"
                >
                  {{ $t("Diamond.main.order") }}
                </a>
              </div>
              <div class="col text-center">
                <a
                  :href="locationsUrl"
                  class="btn btn-md"
                  :class="[
                    shopId > 10000 && articleNr !== '' ? 'set-font-size' : '',
                    diamondData.stone_type === '5'
                      ? 'btn-lab-grown'
                      : 'btn-real-diamond-stock',
                  ]"
                >
                  {{ $t("Diamond.main.appointment") }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="diamond-details" v-if="loading == false">
      <div class="container-md">
        <div class="row">
          <div class="col">
            <h2
              class="p-2"
              :class="
                diamondData.stone_type === '5' ? 'lab-grown' : 'real-diamond'
              "
            >
              {{ $t("Diamond.details.header.main") }}
              <template v-if="diamondData.stone_type === '5'">
                {{ $t("Diamond.details.header.labGrown") }}
              </template>
              <template v-else>
                {{ $t("Diamond.details.header.realDiamond") }}
              </template>
            </h2>
          </div>
        </div>
        <div class="row">
          <div class="col table-responsive table-sm-responsive p-0">
            <table class="table align-middle">
              <tbody>
                <tr>
                  <th scope="row">{{ $t("Diamond.details.table.form") }}</th>
                  <td>{{ diamondData.stoneform }}</td>
                </tr>
                <tr>
                  <th scope="row">{{ $t("Diamond.details.table.carat") }}</th>
                  <td>{{ diamondData.stone_size }} ct.</td>
                </tr>
                <tr>
                  <th scope="row">{{ $t("Diamond.details.table.color") }}</th>
                  <td>{{ diamondData.color }}</td>
                </tr>
                <tr>
                  <th scope="row">{{ $t("Diamond.details.table.purity") }}</th>
                  <td>{{ diamondData.purity }}</td>
                </tr>
                <tr v-if="diamondData.picture === 'a'">
                  <th scope="row">{{ $t("Diamond.details.table.finish") }}</th>
                  <td>{{ diamondData.finish }}</td>
                </tr>
                <tr>
                  <th scope="row">{{ $t("Diamond.details.table.polish") }}</th>
                  <td>{{ diamondData.polish }}</td>
                </tr>
                <tr>
                  <th scope="row">
                    {{ $t("Diamond.details.table.symmetry") }}
                  </th>
                  <td>{{ diamondData.symmetry }}</td>
                </tr>
                <tr>
                  <th scope="row">
                    {{ $t("Diamond.details.table.fluorescence") }}
                  </th>
                  <td>{{ diamondData.fluorescence }}</td>
                </tr>
                <tr>
                  <th scope="row">
                    {{ $t("Diamond.details.table.measurement") }}
                  </th>
                  <td>
                    {{ diamondData.length }} - {{ diamondData.width }} x
                    {{ diamondData.height }} mm
                  </td>
                </tr>
                <tr v-if="diamondData.stone_type === '5'">
                  <th scope="row">
                    {{ $t("Diamond.details.table.labGrown") }}
                  </th>
                  <td>{{ $t("Diamond.details.table.yes") }}</td>
                </tr>
                <tr>
                  <th scope="row">
                    {{ $t("Diamond.details.table.certificate") }}
                  </th>
                  <td>
                    <template
                      v-if="
                        diamondData.certificateNr &&
                        diamondData.certificate === 'GIA'
                      "
                    >
                      <a
                        :href="
                          'https://www.gia.edu/report-check?reportno=' +
                          diamondData.certificateNr
                        "
                        target="_blank"
                      >
                        {{ diamondData.certificate }} -
                        {{ diamondData.certificateNr }}
                      </a>
                    </template>
                    <template
                      v-else-if="
                        diamondData.certificateNr &&
                        diamondData.certificate === 'IGI'
                      "
                    >
                      <a
                        :href="
                          'http://www.igiworldwide.com/verify.php?r=' +
                          diamondData.certificateNr
                        "
                        target="_blank"
                      >
                        {{ diamondData.certificate }} -
                        {{ diamondData.certificateNr }}
                      </a>
                    </template>
                    <template
                      v-else-if="
                        diamondData.certificateNr &&
                        diamondData.certificate === 'HDR'
                      "
                    >
                      {{ diamondData.certificate }} -
                      {{ diamondData.certificateNr }}
                    </template>
                    <template v-else>
                      {{ diamondData.certificate }}
                    </template>
                  </td>
                </tr>
                <tr v-if="shopId > 10000">
                  <th scope="row">
                    {{ $t("Diamond.details.table.supplier") }}
                  </th>
                  <td>{{ diamondData.supplier }}</td>
                </tr>
                <tr>
                  <th scope="row">{{ $t("Diamond.details.table.price") }}</th>
                  <td class="fw-bold">
                    {{ $n(diamondPrice, "currency") }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Loader v-if="loading === true" />
    <Items
      v-if="articleNr !== ''"
      :diamond-id="diamondId"
      :stoneType="diamondData.stone_type"
    />
    <section class="back" v-if="showButton">
      <div class="container-md">
        <div class="row">
          <div class="col-12 pt-5 text-center">
            <button
              class="btn btn-md btn-previous"
              :class="[
                diamondData.stone_type === '5'
                  ? 'btn-outline-lab-grown'
                  : 'btn-outline-real-diamond-stock',
              ]"
              @click="$router.back()"
            >
              {{ $t("Diamond.details.back") }}
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Items from "@/components/Items.vue";
import Loader from "@/components/SpinnerLoader";
import DAODiamond from "@/assets/DAO/Diamond";
import Logger from "@/assets/Helper/Logger";

import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default {
  name: "diamond-data",
  components: {
    Items,
    Loader,
  },
  props: {
    diamondId: {
      required: true,
    },
  },
  setup: function (props) {
    const router = useRouter();
    const store = useStore();
    const appUrl = store.getters["config/getAppUrl"];
    const id = ref(props.diamondId);
    const diamondData = ref({});
    const articleNr = ref("");
    const loading = ref(true);
    const backUrl = router.options.history.state.back;
    const showButton =
      router.resolve({ path: `${backUrl}` }).name !== "not-found";

    //const isOnWishList		= ref({});

    function searchDiamond() {
      DAODiamond.getData(store.getters["config/getCountry"], id.value).then(
        async (response) => {
          if (response === false) {
            await router.push({ name: "404" });
          } else {
            diamondData.value = response.article;
            loading.value = false;
          }

          await getArticleNr();
        }
      );

      window.scrollTo(0, 0);
    }

    async function getArticleNr() {
      DAODiamond.getItemnumber(id.value).then(
        (response) => {
          if (typeof response === "string" && response !== false) {
            articleNr.value = response;
          }
        },
        (alerts) => {
          if (typeof alerts == "object" && alerts.length > 0) {
            Logger.debug("Alerts", alerts);

            for (let key in alerts) {
              Notification.create(alerts[key].title, alerts[key].text);
            }
          } else {
            Logger.debug("No alerts set", alerts);
          }
        }
      );
    }

    onMounted(() => {
      searchDiamond();
    });

    return {
      appUrl,
      router,
      showButton,
      loading,
      articleNr,
      diamondData,
      shopId: computed(() => store.getters["config/getActiveShop"]),
      diamondPrice: computed(() => {
        return parseFloat(
          diamondData.value["price"].replace(",-", "").replace(".", "")
        );
      }),
      locationsUrl: computed(() => {
        return typeof window.diamondStockConfig.locationsUrl === "string" &&
          window.diamondStockConfig.locationsUrl !== ""
          ? window.diamondStockConfig.locationsUrl
          : "/";
      }),
      configuratorUrl: computed(() => {
        return typeof window.diamondStockConfig.configuratorUrl === "string" &&
          window.diamondStockConfig.configuratorUrl !== ""
          ? window.diamondStockConfig.configuratorUrl
          : "/";
      }),
    };
  },
};
</script>
<style lang="scss" scoped>
#DiamondData {
  position: relative;

  .diamond-header {
    padding-bottom: 3rem;
    background-color: #f0f0f0;

    .set-height {
      min-height: 4rem;
    }

    .set-pt {
      padding-top: 0.75rem;
      z-index: 1;
    }

    .btn-lab-grown,
    .btn-diamond-stock {
      &.set-font-size {
        @media (max-width: 360px) {
          font-size: 1.2rem;
        }

        @media (min-width: 576px) and (max-width: 610px) {
          font-size: 1.25rem;
        }
      }
    }

    .btn-close {
      width: 2rem;
      font-size: 1.75rem;
    }

    .set-mt {
      margin-top: -3rem;
    }


    p {
      span {
        &.set-color {
          color: #fff;
          background: $labGrownColor;
        }
      }
    }

    .diamond-clip {
      height: auto;
      width: 100%;
      max-width: 25rem;

      @media #{$md} {
        margin-bottom: 0.5rem;
      }
    }

    img {
      width: 100%;
      max-width: 20rem;

      @media #{$sm} {
        margin-bottom: 0.75rem;
      }

      @media #{$md} {
        max-width: 25rem;
        margin-bottom: 0.25rem;
      }

      @media #{$lg} {
        margin-bottom: 0;
      }
    }

    .price {
      font-size: 2rem;
      text-align: center;
      margin: 1rem 0 3rem;

      @media #{$sm} {
        margin: 3rem 0 5.5rem;
      }

      @media #{$md} {
        margin: 2.25rem 0 4rem;
      }

      @media #{$lg} {
        margin: 3.25rem 0 6rem;
      }
    }

    .appointmentOrOrder {
      .btn-md {
        line-height: 1.5rem;
      }
    }

    @media #{$sm} {
      padding-bottom: 3rem;
    }

    @media #{$lg} {
      background-color: #f2f2f2;
    }
  }

  .diamond-details {
    margin-top: 4rem;

    h2 {
      margin-bottom: 1rem;

      &.lab-grown {
        color: $labGrownColor;
      }

      &.real-diamond {
        color: $realDiamondColor;
      }
    }

    .table-responsive {
      table {
        font-size: 1.4rem !important;

        th {
          padding-left: 1rem;
        }

        @media #{$sm} {
          font-size: 1.3rem !important;
        }

        @media #{$md} {
          font-size: 1.6rem !important;
        }
      }

      tr:nth-child(odd) {
        background-color: #f2f2f2;
      }

      @media #{$sm} {
        tr {
          width: 50%;
          float: left;

          th {
            display: inline-block;
            width: 40%;
          }

          td {
            display: inline-block;
            width: 60%;
          }

          &:nth-child(odd) {
            background-color: transparent;
          }

          &:nth-child(1),
          &:nth-child(2),
          &:nth-child(5),
          &:nth-child(6),
          &:nth-child(9),
          &:nth-child(10) {
            background-color: #f2f2f2;
          }
        }
      }
    }

    .btn-previous {
      margin-top: 4rem;
    }
  }
}
</style>
